import { render, staticRenderFns } from "./Registert.vue?vue&type=template&id=72fca2d1&scoped=true&"
import script from "./Registert.vue?vue&type=script&lang=js&"
export * from "./Registert.vue?vue&type=script&lang=js&"
import style0 from "./Registert.vue?vue&type=style&index=0&id=72fca2d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fca2d1",
  null
  
)

export default component.exports